module.exports = __webpack_public_path__ + "static/media/runbtn.62c96a12.svg";